var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"instruction"},[_c('TrackCard',{attrs:{"trackProps":_vm.trackProps}},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.instruction)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }